import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Dropdown, Form, OverlayTrigger, Pagination, Row, Tooltip } from "react-bootstrap";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { components } from "react-select";
import CreatableSelect from 'react-select/creatable';

// css
import styles from "./common.module.scss";
import { useField, useFormikContext } from "formik";
import { errorMessageToast, userFullName } from "helpers/common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "react-feather";
import { useGetActiveSchoolBannersListQuery } from "store/services/schoolBanners.service";


export const reportDropdownStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#c4c4c433", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
  }),

  menu: (provided) => ({
    ...provided,
    fontFamily: "proxima nova",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "#000" : "#000", // Change text color based on selection
  }),
}

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#c4c4c433", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
    // minHeight: "55px",
  }),


  menu: (provided) => ({
    ...provided,
    fontFamily: "proxima nova",
  }),
  option: (provided, state) => ({
    ...provided,
    // backgroundColor: state.isSelected
    //   ? "#007BFF"
    //   : state.isFocused
    //   ? "#e2e2e2"
    //   : "#f0f0f0",
    color: state.isSelected ? "#000" : "#000", // Change text color based on selection
    borderBottom: "1px solid #ddd",
    "&:hover": {
      // backgroundColor: "#007BFF",
      color: "#000", // Change text color on hover
    },
  }),
};

const customStyleForFilterSelect = {
  ...selectCustomStyles,
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#c4c4c433", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
    minWidth: "150px"
  }),
};

const SelectDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
      >
        <path
          d="M6.99995 7.4521L0.0273438 0.479492H13.9726L6.99995 7.4521Z"
          fill="#1C1B1F"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

export const CstmPagination = ({
  activePage = 1,
  handlePageChange = () => { },
  totalPages = 1,
  maxPagesToShow = 5,
  className
}) => {

  const renderPaginationItems = () => {
    let items = [];

    const startPage = Math.max(1, activePage - 2); // Start two pages before the active page
    const endPage = Math.min(totalPages, activePage + 2); // End two pages after the active page

    // Add first page
    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} active={1 === activePage} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );

      // Add ellipsis after the first page if needed
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Add pages around the active page
    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Add last page
    if (endPage < totalPages) {
      // Add ellipsis before the last page if needed
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }

      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === activePage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div
      className={`${styles.cstmPagination} ${className && className} cstmPagination d-flex align-items-center flex-wrap justify-content-end gap-10`}
    >
      <div className="right d-flex align-items-center gap-10">
        {/* <p className="m-0 fw-sbold text-dark">1-2 of items</p> */}
        <Pagination>
          <Pagination.Prev
            className="prev"
            onClick={() => handlePageChange(Math.max(activePage - 1, 1))}
            disabled={activePage === 1}
          />
          {renderPaginationItems()}
          <Pagination.Next
            className="next"
            onClick={() => handlePageChange(Math.min(activePage + 1, totalPages))}
            disabled={activePage === totalPages}
          />
        </Pagination>
      </div>
    </div>
  );
};

export const Rating = ({ size }) => {
  return (
    <>
      <ul
        className={`${styles.rating} list-unstyled ps-0 mb-0 d-flex align-items-center`}
      >
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#FFC500"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5554)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#E0E8F1"
              />
              <mask
                id="mask0_22_5554"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
              >
                <path
                  d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                  fill="#E0E8F1"
                />
              </mask>
              <g mask="url(#mask0_22_5554)">
                <rect width="9" height="17.1907" fill="#FFC500" />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_22_5554">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
        <li className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
          >
            <g clip-path="url(#clip0_22_5548)">
              <path
                d="M9.44071 14.5436C9.16931 14.3792 8.829 14.3792 8.55761 14.5437L4.39532 17.0665C3.75017 17.4575 2.95263 16.8789 3.12406 16.1443L4.22755 11.4153C4.29924 11.1081 4.19529 10.7864 3.95739 10.5792L0.293637 7.38862C-0.273874 6.8944 0.031211 5.96092 0.781053 5.89724L5.60934 5.48723C5.92375 5.46053 6.19766 5.26223 6.3212 4.97188L8.21605 0.518403C8.51015 -0.172801 9.48985 -0.172801 9.78395 0.518404L11.6788 4.97188C11.8023 5.26224 12.0762 5.46053 12.3907 5.48723L17.2189 5.89724C17.9688 5.96092 18.2739 6.8944 17.7064 7.38862L14.0426 10.5792C13.8047 10.7864 13.7008 11.1081 13.7725 11.4153L14.876 16.1446C15.0474 16.8792 14.25 17.4578 13.6048 17.0668L9.44071 14.5436Z"
                fill="#E0E8F1"
              />
            </g>
            <defs>
              <clipPath id="clip0_22_5548">
                <rect width="18" height="17.25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </li>
      </ul>
    </>
  );
};


export const CommonSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  onInputChange,
  isFilter,
  isFilterV2,
  value,
  ...props
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = name ? useField(name) : [];


  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  const renderComponent = () => {
    return (
      creatable ? (
        <CreatableSelect
          // isClearable 
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          classNamePrefix={"khan"}
          options={options}
          styles={isFilterV2 ? selectCustomStyles : isFilter ? customStyleForFilterSelect : selectCustomStyles}
          // styles={selectCustomStyles}
          onChange={handleFieldChange}
          defaultValue={defaultValue}
          onInputChange={onInputChange}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <Select
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          classNamePrefix={"khan"}
          options={options}
          styles={isFilterV2 ? selectCustomStyles : isFilter ? customStyleForFilterSelect : selectCustomStyles}
          onChange={handleFieldChange}
          value={(field?.value || value || null)}
          defaultValue={defaultValue}
          {...props}
          onInputChange={onInputChange}
          isLoading={isLoading}

        />
      )
    )
  }

  return (
    <>
      {renderComponent()}
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta?.error === "string" ? meta.error : meta?.error?.value}</div>
      ) : null}
    </>
  );
};

export const CommonDropdown = ({ onChange, title, options }) => {
  return (
    <Dropdown
      onSelect={onChange}
    >
      <Dropdown.Toggle
        variant="transparent"
        className="border-0 d-flex align-items-center  justify-content-center"
        id="dropdown-basic"
      >
        {title}
        <span className="icn ms-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
              fill="black"
            />
          </svg>
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options?.length > 0 && (
          options.map((item, index) => {
            return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
          })
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export const NoRecordFound = ({ showBorder }) => {

  return (
    <div className={`py-2 d-flex align-items-center justify-content-center w-100 ${showBorder && "parents-detail-wrapper"}`}>
      No Record Found
    </div>
  )
};

export const RequiredFieldAstrick = () => {

  return <span className="required-astrick">*</span>
}

export const CommonToolTip = ({ component, text }) => {

  return (
    <div>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="top"
        overlay={
          <Tooltip style={{ position: "fixed" }}>
            {text}
          </Tooltip>
        }
      >
        {component}
      </OverlayTrigger>
    </div>
  )
}

export const CommonMultiSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  onInputChange,
  onRemove,
  isDisabled
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = useField(name) || {};

  const handleFieldChange = (selected) => {

    if (selected?.length < (field?.value?.length || 0)) {

      const removedItems = field?.value?.filter(item => !selected.find(selectedItem => selectedItem.value === item.value)) || [];
      if (removedItems.length > 0 && typeof onRemove === "function" && removedItems[0]?.selected) {
        onRemove(removedItems[0], setFieldValue);
        return;
      }
    };

    name && typeof setFieldValue === "function" && setFieldValue(name, selected);
    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  const renderComponent = () => {
    return (
      <Select
        isMulti
        placeholder={isLoading ? "Loading..." : placeholder}
        components={optionProps}
        options={options}
        styles={selectCustomStyles}
        onChange={handleFieldChange}
        onBlur={handleBlur}
        value={(field?.value || null)}
        defaultValue={defaultValue}
        closeMenuOnSelect={false}
        onInputChange={onInputChange}
        isClearable={false}
        isDisabled={isDisabled}
      />
    )
  }
  return (
    <>
      {renderComponent()}
      {(meta.touched && meta.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};

export const CustomAsyncSelect = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  value,
  defaultValue,
  loadOptions,
  defaultOptions,
  isFilter,
  ...props
}) => {
  const { setFieldValue } = useFormikContext() || {};
  const [field, meta] = name ? useField(name) : [];

  console.log('field Data', field)

  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        placeholder={placeholder}
        components={optionProps}
        classNamePrefix={"khan"}
        styles={isFilter ? customStyleForFilterSelect : selectCustomStyles}
        onChange={handleFieldChange}
        onBlur={handleBlur}
        value={(field?.value || value || null)}
        defaultValue={defaultValue}
        defaultOptions={defaultOptions}
        {...field}
        {...props}
      />
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
      ) : null}
    </>
  );
};

export const PdfPublishForm = ({ handleSubmit, guardianList, clientType = "school", setShowSubmitModal, publishPdfCheckbox = false }) => {
  const { values, setFieldValue, errors, touched, setFieldTouched, isSubmitting } = useFormikContext()
  const generatePassword = () => {
    const newPass = Math.random().toString(36).slice(-8);
    setFieldValue("emailFormData.pdfPassword", newPass);
  };

  const guardians = useMemo(() => {
    if (!guardianList?.length) return [];

    return guardianList.filter((guardian) => {
      const slug = guardian?.client_guardian?.client_role?.slug;
      if (slug !== (clientType === "school" ? "teacher" : "parent")) {
        return false;
      }

      return true;
    })
  }, [guardianList]);

  console.log('guardians', guardians)

  return (
    // <div style={{ width: "379px", padding: "20px", backgroundColor: "white", position: "absolute", right: "80px", top: "87px", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
    <div
      className="proxima-regular"
      style={{
        // margin: "20px auto",
        // padding: "20px",
        // border: "1px solid #ddd",
        borderRadius: "6px",
        background: "#fff",
        position: "relative"
      }}
    >
      {/* Header */}
      {/* <Row style={{ marginBottom: "10px" }}>
          <Col style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h6
              style={{
                margin: 0,
                width: "100%",
                fontSize: "14px",
                fontWeight: "800",
                textTransform: "uppercase",
                borderBottom: "1px solid #315D99",
                color: "#315D99",
              }}
            >
              Submit & Export
            </h6>
          </Col>
        </Row> */}

      {/* Email To */}
      <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "15px" }}>
        {/* <p style={{
            fontSize: "14px", marginBottom: "10px", textTransform: "uppercase",
            borderBottom: "1px solid #315D99",
            fontWeight: "600",
            color: "#315D99",
          }}>Email To</p> */}
        {guardians?.length > 0 ?
          guardians
            .map((guardian, index) => {
              const slug = guardian?.client_guardian?.client_role?.slug;
              if (slug !== (clientType === "school" ? "teacher" : "parent")) {
                return null;
              }
              if ([0, 1].includes(index)) {
                return (
                  <div className="d-flex gap-2 mb-2">
                    <input
                      type="checkbox"
                      className="form-check"
                      style={{ accentColor: "#b46c9f", height: 20, width: 20, }}
                      // disabled={true}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        let role = ""
                        if (slug == 'teacher') {
                          role = index === 0 ? "teacher" : "coordinator";
                        }
                        else {
                          role = index === 0 ? "parent1" : "parent2";
                        }
                        const guardianData = { id: guardian?.client_guardian?.id, role, firstname: guardian?.client_guardian?.firstname, lastname: guardian?.client_guardian?.lastname, email: guardian?.client_guardian?.email };

                        const currentList = values.emailFormData?.recipientList || [];

                        let updatedList;
                        if (isChecked) {
                          updatedList = [...currentList, guardianData];
                        } else {
                          updatedList = currentList.filter((item) => item.id !== guardian?.client_guardian?.id);
                        }

                        setFieldValue('emailFormData.recipientList', updatedList);
                      }}
                      checked={values?.emailFormData?.recipientList?.some((item) => item?.id === guardian?.client_guardian?.id)}
                    />
                    <div className="proxima-regular" style={{ fontSize: "14px", color: "#000" }}>
                      <strong style={{ color: "#000" }}>{slug == "teacher" ? index == 0 ? "Teacher" : "Coordinator" : `Parent/Guardian ${index + 1}`}:</strong>
                      <p className="mb-0">
                        {userFullName(guardian?.client_guardian)}
                      </p>
                      <p className="mb-0">
                        {guardian?.client_guardian?.email}
                      </p>
                    </div>
                  </div>
                );
              }
              else {
                return
              }
            }) : (
            <div className={`d-flex align-items-center justify-content-center w-100 guardian-not-assigned-wrapper py-2`}>
              <p className="m-0">No {clientType == "schhol" ? 'teacher' : 'parent'} is currently assigned to this client.</p>
            </div>
          )}


        {/* Password */}
        {
          guardians?.length > 0 &&
          < div className="proxima-regular" style={{ marginTop: "15px", display: "flex", alignItems: "center", gap: "5px", maxWidth: "400px" }}>
            <label style={{ fontSize: "13px", whiteSpace: "nowrap", fontWeight: "bold" }}>Add a Password:</label>
            <div className="w-100">
              <AppInputField style={{ width: "100%", padding: "8px", border: "1px solid #ccc", fontFamily: "Proxima Nova" }} name={"emailFormData.pdfPassword"} />
              <div className="error">
                {(touched?.emailFormData?.pdfPassword && !values?.emailFormData?.pdfPassword && values?.emailFormData?.recipientList?.length > 0) && "Password is required"}
              </div>
            </div>
          </div>
        }
      </div>

      {/* Publish Report */}
      {
        publishPdfCheckbox &&
        <div style={{ marginTop: "15px", paddingBottom: "15px" }}>
          <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
            <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99", padding: 0 }}>{"PUBLISH REPORT TO"}</h6>
          </div>
          <label style={{
            display: "flex", alignItems: "center", gap: "8px", fontSize: "14px",
            // color: clientType == "school" ? "#999" : "",
            color: "#999"
          }}
          >
            <input
              type="checkbox"
              className="form-check"
              style={{ accentColor: "#b46c9f", height: 20, width: 20, borderColor: "#999" }}
              // disabled={previewMode}
              onChange={(e) => {
                const isChecked = e.target.checked;
                if (isChecked) {
                  setFieldValue('emailFormData.publishReport', "yes")
                } else {
                  setFieldValue('emailFormData.publishReport', "no")
                }
              }}
              checked={values?.emailFormData?.publishReport == 'yes'}
              // disabled={clientType == "school" ? true : false}
              disabled={true}
            />
            {clientType == "school" ? 'Teacher' : 'Parent'} Dashboard
          </label>
        </div>
      }

      {/* Done Button */}
      <div style={{ display: "flex", justifyContent: "end", textAlign: "right", marginTop: "15px" }}>
        <button disabled={isSubmitting} className="d-flex align-items-center gap-2 justify-content-center discharge-screen" type='button' onClick={() => {
          if (isEmpty(errors) && (values?.emailFormData?.pdfPassword || !values?.emailFormData?.recipientList?.length)) {
            setFieldValue('saveForLater', false); handleSubmit()
          }
          else {
            setFieldTouched("emailFormData.pdfPassword", true);
            errorMessageToast("There are errors in the form. Please check your entries and correct them.")
          }
        }} style={{ background: "#0d3e7d" }}>
          Done
        </button>
      </div>
    </div >
    // </div>
  )
}


export const PdfPublishFormClassroom = ({ handleSubmit, guardianList, clientType, setShowSubmitModal, publishPdfCheckbox = false }) => {
  const { values, setFieldValue, errors, touched, setFieldTouched } = useFormikContext()
  const generatePassword = () => {
    const newPass = Math.random().toString(36).slice(-8);
    setFieldValue("emailFormData.pdfPassword", newPass);
  };

  const guardians = useMemo(() => {
    if (!guardianList?.length) return [];

    return guardianList.filter((guardian) => {
      const slug = guardian?.role;
      if (slug !== (clientType === "school" ? "teacher" : "parent")) {
        return false;
      }

      return true;
    })
  }, [guardianList]);
  return (
    <div
      className="proxima-regular"
      style={{
        borderRadius: "6px",
        background: "#fff",
        position: "relative"
      }}
    >
      <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "15px" }}>

        {guardians?.length > 0 ?
          guardians
            .map((guardian, index) => {
              const slug = guardian?.role;
              if (slug !== (clientType === "school" ? "teacher" : "parent")) {
                return null;
              }
              if ([0, 1].includes(index)) {
                return (
                  <div className="d-flex gap-2 mb-2">
                    <input
                      type="checkbox"
                      className="form-check"
                      style={{ accentColor: "#b46c9f", height: 20, width: 20, }}
                      // disabled={true}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        let role = ""
                        if (slug == 'teacher') {
                          role = index === 0 ? "teacher" : "coordinator";
                        }
                        else {
                          role = index === 0 ? "parent1" : "parent2";
                        }

                        const currentList = values.emailFormData?.recipientList || [];

                        let updatedList;
                        if (isChecked) {
                          updatedList = [...currentList, guardian];
                        } else {
                          updatedList = currentList.filter((item) => item.id !== guardian?.id);
                        }

                        setFieldValue('emailFormData.recipientList', updatedList);
                      }}
                      checked={values?.emailFormData?.recipientList?.some((item) => item?.id === guardian?.id)}
                    />
                    <div className="proxima-regular" style={{ fontSize: "14px", color: "#000" }}>
                      <strong style={{ color: "#000" }}>{index == 0 ? "Teacher" : "Coordinator"}:</strong>
                      <p className="mb-0">
                        {userFullName(guardian)}
                      </p>
                      <p className="mb-0">
                        {guardian?.email}
                      </p>
                    </div>
                  </div>
                );
              }
              else {
                return
              }
            }) : (
            <div className={`d-flex align-items-center justify-content-center w-100 guardian-not-assigned-wrapper py-2`}>
              <p className="m-0">No teacher is currently assigned to this client.</p>
            </div>
          )}


        {/* Password */}
        {
          guardians?.length > 0 &&
          <div className="proxima-regular" style={{ marginTop: "15px", display: "flex", alignItems: "center", gap: "5px", maxWidth: "400px" }}>
            <label style={{ fontSize: "13px", whiteSpace: "nowrap", fontWeight: "bold" }}>Add a Password:</label>
            <div className="w-100">
              <AppInputField style={{ width: "100%", padding: "8px", border: "1px solid #ccc", fontFamily: "Proxima Nova" }} name={"emailFormData.pdfPassword"} />
              <div className="error">
                {(touched?.emailFormData?.pdfPassword && !values?.emailFormData?.pdfPassword && values?.emailFormData?.recipientList?.length > 0) && "Password is required"}
              </div>
            </div>
          </div>
        }
      </div>

      {/* Publish Report */}
      {
        publishPdfCheckbox &&
        <div style={{ marginTop: "15px", paddingBottom: "15px" }}>
          <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
            <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99", padding: 0 }}>{"PUBLISH REPORT TO"}</h6>
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "#999" }}>
            <input
              type="checkbox"
              className="form-check"
              style={{ accentColor: "#b46c9f", height: 20, width: 20, borderColor: "#999" }}
              // disabled={previewMode}
              onChange={(e) => {
                const isChecked = e.target.checked;
                if (isChecked) {
                  setFieldValue('emailFormData.publishReport', "yes")
                } else {
                  setFieldValue('emailFormData.publishReport', "no")
                }
              }}
              checked={values?.emailFormData?.publishReport == 'yes'}
              disabled
            />
            Teacher Dashboard
          </label>
        </div>
      }

      {/* Done Button */}
      <div style={{ display: "flex", justifyContent: "end", textAlign: "right", marginTop: "15px" }}>
        <button className="d-flex align-items-center gap-2 justify-content-center discharge-screen" type='button' onClick={() => {
          if (isEmpty(errors) && (values?.emailFormData?.pdfPassword || !values?.emailFormData?.recipientList?.length)) {
            setFieldValue('saveForLater', false); handleSubmit()
          }
          else {
            setFieldTouched("emailFormData.pdfPassword", true);
            errorMessageToast("There are errors in the form. Please check your entries and correct them.")
          }
        }} style={{ background: "#0d3e7d" }}>
          Done
        </button>
      </div>
    </div>
    // </div>
  )
}

export const Breadcrumbs = ({ items = [], style }) => {
  return (
    <Col lg="12">
      <div className="pageHead proxima d-flex align-items-center justify-content-between flex-wrap gap-10">
        <div className="left">
          <ul className="list-unstyled gap-2 ps-0 mb-0 d-flex align-items-center">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <li>
                  {item.path ? (
                    <Link
                      to={item.path}
                      className="themeBlue"
                      style={{ textDecoration: "underline", ...style }}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <h5 className="m-0" style={{ ...style }}>{item.label}</h5>
                  )}
                </li>
                {index < items.length - 1 && <span>/</span>}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </Col>
  );
};


export const NoRecordFoundV2 = ({ message = "No Record Found", style = {}, className = "" }) => {
  return (
    <div style={{ ...style }} className={`${className} classroom-no-reports mt-2 w-100`}>
      <p>{message}</p>
    </div>
  )
}

export function BannerCarousel({ autoplayInterval = 4000 }) {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const { data: slides = [], isLoading: bannersLoading, isFetching: bannersFetching } = useGetActiveSchoolBannersListQuery();

  const next = () => setActive((i) => (i + 1) % slides.length);
  const prev = () => setActive((i) => (i - 1 + slides.length) % slides.length);

  // Autoplay
  useEffect(() => {
    if (isPaused || slides.length <= 1) return;
    intervalRef.current = setInterval(next, autoplayInterval);
    return () => clearInterval(intervalRef.current);
  }, [isPaused, slides.length, autoplayInterval]);

  if (!slides.length) return null;

  const slide = slides[active];

  return (
    <>
      <div
        className="banner-carousel"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="banner-carousel">
        {/* Background image from API */}
        <div
          className="banner-carousel__bg"
          style={{
            backgroundImage: slide.banner_image ? `url(${slide.banner_image})` : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Left arrow */}
        <button
          className="banner-carousel__arrow banner-carousel__arrow--left"
          onClick={prev}
          aria-label="Previous slide"
        >
          <ChevronLeft color="black" size={24} />
        </button>

        {/* Right arrow */}
        <button
          className="banner-carousel__arrow banner-carousel__arrow--right"
          onClick={next}
          aria-label="Next slide"
        >
          <ChevronRight color="black" size={24} />
        </button>

        {/* Dot indicators */}
        <div className="banner-carousel__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`banner-carousel__dot${i === active ? " banner-carousel__dot--active" : ""}`}
              onClick={() => setActive(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        {/* Content card */}
        <div className="banner-carousel__card">
          <h2>{slide.title}</h2>
          {/* description comes as HTML string from API */}
          <div
            className="banner-carousel__desc"
            dangerouslySetInnerHTML={{ __html: slide.description }}
          />
          {slide.link_url && (
            <a
              href={slide.link_url}
              target="_blank"
              rel="noopener noreferrer"
              className="banner-carousel__link"
            >
              Learn more →
            </a>
          )}
        </div>
      </div>
      </div>
    </>
  );
}